<template>
    <div>
        <form>
            <div v-if="!inline" class="form-line" style="margin-bottom: 5px;">
                <div class="form-field" id="form-field-question-type">
                    <label for="form-input-question-type">Question Type</label>
                    <select id="form-input-question-type" v-model="model.type" required>
                        <option v-for="qtype in questionTypes" :key="qtype.value" :value="qtype.value">
                            {{ qtype.text }}
                        </option>
                    </select>
                </div>
            </div>
            <div v-if="!inline" class="form-line" style="margin-bottom: 5px;">
                <div class="form-field" id="form-field-question-name">
                    <label for="form-input-question-name">Question Name</label>
                    <input id="form-input-question-name" type="text" v-model="model.name" required />
                </div>
            </div>
            <div class="form-line">
                <div class="form-field form-field-checkbox" id="form-field-required">
                    <input id="form-input-required" type="checkbox" v-model="model.required">
                    <label for="form-input-required" class="checkbox-label">Required</label>
                </div>
            </div>
            <div v-if="['opinion-scale'].includes(model.type)" class="form-line">
                <div class="form-field" id="form-field-select-page" style="width: 50%">
                    <label for="form-input-select-page">Min Value</label>
                    <select id="form-input-select-page" v-model="model.start_from_zero">
                        <option :value="0">0</option>
                        <option :value="1">1</option>
                    </select>
                </div>
                <div class="form-field" id="form-field-select-page" style="width: 50%">
                    <label for="form-input-select-page">Max Value</label>
                    <select id="form-input-select-page" v-model="model.max_value">
                        <option v-for="i in 5" :value="i+5">{{ i + 5 }}</option>
                    </select>
                </div>
            </div>
            
            <div v-if="['rating'].includes(model.type)"
                 class="form-line tw-w-ful tw-text-left tw-items-center tw-gap-2 tw-mb-3 tw-whitespace-nowrap">
                <div class="form-field" id="form-field-select-page" style="width: 50%">
                    <label for="form-input-select-page">No of Stars</label>
                    <select id="form-input-select-page" :value="model.max_value || 5" @input="model.max_value = $event.target.value">
                        <option v-for="i in 8" :value="i+2">{{ i + 2 }}</option>
                    </select>
                </div>
            </div>
            <div v-if="['boolean'].includes(model.type)" class="form-line tw-w-full tw-mb-3">
                <div class="form-field form-field-boolean">
                    <div class="tw-w-full tw-text-left">
                        <label class="tw-text-sm">Yes Value</label>
                        <input class="tw-form-input" type="text" v-model="model.yes_value" placeholder="Yes">
                    </div>
                    <div class="tw-w-full tw-text-left">
                        <label class="tw-text-sm">No Value</label>
                        <input class="tw-form-input" type="text" v-model="model.no_value" placeholder="No">
                    </div>
                </div>
            </div>

            <div v-if="['single-choice', 'multiple-choice', 'ranking'].includes(model.type)"
                class="form-line tw-text-left">
                <div class="form-field form-field-options">
                    <label>Options</label>
                    <draggable v-model="model.options">
                        <div v-for="(option, index) in model.options" :key="index"
                            class="option tw-flex tw-gap-2 tw-items-center tw-mb-2">
                            <span class="remove" @click="model.options.splice(index, 1)">X</span>
                            <span class="tw-w-full">
                                <input type="text" class="tw-w-full tw-form-input" v-model="model.options[index]">
                            </span>
                        </div>
                    </draggable>
                    <div v-if="model.other_option" class="option other tw-flex tw-gap-2 tw-items-center tw-mb-2">
                        <span class="remove" @click="$set(model, 'other_option', false)">X</span>
                        <span class="tw-p-1">Other</span>
                    </div>
                    <div class="tw-my-3">
                        <span class="ws-button tw-text-xs" @click="model.options.push('')">Add Option</span>
                        <span v-if="!model.other_option && model.type === 'single-choice'" class="ws-button tw-text-xs"
                            @click="$set(model, 'other_option', true)">Add Other Option</span>
                    </div>
                </div>
            </div>
        </form>
        <div class="form-actions" v-if="!inline">
            <div class="ws-button ws-button-secondary" @click="onCancel">Cancel</div>
            <div class="ws-button ws-button-main" @click="onSubmit">Save</div>
        </div>
    </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
    name: 'QuestionSettingsForm',
    components: { draggable },
    props: {
        question: {
            type: Object,
            default: () => ({
                name: undefined,
                id: undefined,
                type: undefined,
                start_from_zero: undefined,
                max_value: undefined,
                yes_value: undefined,
                no_value: undefined,
            })
        },
        inline: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            model: {
                name: undefined,
                id: undefined,
                type: undefined,
                start_from_zero: undefined,
                max_value: undefined,
                yes_value: undefined,
                no_value: undefined,
            },
            questionTypes: [
                { value: 'short-text', text: 'Short text' },
                { value: 'email', text: 'Email' },
                { value: 'phone-number', text: 'Phone number' },
                { value: 'date', text: 'Date' },
                { value: 'website', text: 'Website' },
                { value: 'number', text: 'Number' },
                { value: 'long-text', text: 'Long text' },
                { value: 'single-choice', text: 'Single choice' },
                { value: 'multiple-choice', text: 'Multiple choice' },
                { value: 'opinion-scale', text: 'Opinion scale' },
                { value: 'rating', text: 'Rating' },
                { value: 'ranking', text: 'Ranking' },
                { value: 'boolean', text: 'Boolean' },
            ]
        }
    },
    watch: {
        model: {
            deep: true,
            handler(question) {
                this.$emit('input', question);
            }
        }
    },
    created() {
        this.resetModel()
    },
    methods: {
        onSubmit() {
            this.$emit('save', this.model);
        },
        onCancel() {
            this.$emit('cancel');
        },
        resetModel() {
            this.model = { ...this.question };
            if (!this.model.options) {
                this.$set(this.model, 'options', []);
            }
        }
    },
}
</script>
